import React, { useEffect, useState } from "react"
import { FPaquetesStyle } from "./styles"
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
} from "@material-ui/core"
import TablaRegistro from "./TablaResgistro"
import useCatalogos from "../../../hooks/useCatalogos"
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch, useSelector } from "react-redux"
import { obtenerPLazasPaqueteTerrestre, closeModalPlazaPaqueteTerrestre, crearPlazaPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck"
import HeaderModal from "../../../global/headerModal"
import InputAdornment from "@material-ui/core/InputAdornment"
import ModalBase from "../../../global/ModalBase"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"

const usePlazaPaqueteTerrestre = () => {
  const dispatch = useDispatch()
  const { paqueteSelect } = useSelector(store => store.proveedorTerrestre)
  useEffect(() => {
    dispatch(onLoadAnction({ message: "" }))
    dispatch(obtenerPLazasPaqueteTerrestre({ idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre })).then(Response => {
      dispatch(offLoadAction())
    })
  }, [dispatch, paqueteSelect?.IdPaqueteProveedorTerrestre])
}

const FPlazaPaqueteTerrestre = () => {
  const { paqueteSelect, openPlazaTerrestre, listaPlazasTerrestre } = useSelector(store => store.proveedorTerrestre)
  const dispatch = useDispatch()
  const classes = FPaquetesStyle()
  const catTipoPlaza = useCatalogos("TipoPlaza")
  const [idTipoPlaza, setIdTipoPlaza] = useState(0)
  const [suplemento, setSuplemento] = useState(0)
  const [disponibilidad, setDisponibilidad] = useState(0)
  usePlazaPaqueteTerrestre()

  const onGuardar = () => {
    if (listaPlazasTerrestre.find(habitacion => habitacion.TipoPlaza.IdTipoPlaza === idTipoPlaza)) {
      ToastMessage.fire({
        icon: "warning",
        title: "<strong>Atención</strong>",
        text: "Este tipo de plaza ya fue asignado.",
      })
      return
    }

    let payload = {
      idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre,
      idTipoPlaza: idTipoPlaza,
      suplemento: suplemento,
      disponibilidad: disponibilidad,
    }
    dispatch(onLoadAnction({ message: "" }))
    dispatch(crearPlazaPaqueteTerrestre(payload)).then((Response) => {
      if (Response.status === 500) {
        ToastMessage.fire({
          icon: "error",
          title: "Ha habido un problema de conexión con el servidor",
        })
        return
      }
      if (Response.status === 400) {
        ToastMessage.fire({
          icon: "warning",
          title: "<strong>Atención</strong>",
          text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
        })
      }
      LimpiarForm()
      dispatch(
        obtenerPLazasPaqueteTerrestre({ idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre })).then((Response) => {
          dispatch(offLoadAction())
          ToastMessage.fire({
            icon: "success",
            title: "Ingreso Correcto",
          })
        })
    })
  }
  const LimpiarForm = () => {
    setIdTipoPlaza(0)
    setSuplemento(0)
    setDisponibilidad(0)
  }
  const handleClose = () => {
    LimpiarForm()
    dispatch(closeModalPlazaPaqueteTerrestre())
  }
  const handleSelect = (event) => {
    setIdTipoPlaza(event.target.value)
  }
  return (
    <ModalBase classes={classes} open={openPlazaTerrestre} onClose={handleClose}>
      <HeaderModal
        titulo={`Habitaciones para el paquete ${paqueteSelect?.Nombre}`}
        handleClose={handleClose}
      />
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={6}>
          <TablaRegistro />
        </Grid>
        <Grid item xs={6}>
          <Grid container className={classes.containerSpacing}>
            <Grid item xs={12}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="SLTipoPlaza">Tipo plaza</InputLabel>
                <Select
                  labelId="SLTipoPlaza"
                  id="SLTipoPlaza"
                  name="tipoPlaza"
                  value={idTipoPlaza}
                  onChange={handleSelect}
                  label="Tipo plaza"
                >
                  <MenuItem value="0" disabled>
                    {"Seleccione una opción"}
                  </MenuItem>
                  {catTipoPlaza.map((item, index) => (
                    <MenuItem key={item.IdTipoPlaza} value={item.IdTipoPlaza}>
                      {`${item.Descripcion} - ${item.Personas} huésped`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                id="input-Suplemento"
                label="Suplemento"
                type="text"
                variant="outlined"
                name="suplemento"
                value={suplemento}
                onChange={(event) => {
                  setSuplemento(event.target.value);
                }}
                className={classes.textField}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      {paqueteSelect?.Moneda ? `${paqueteSelect?.Moneda.Clave}` : ""}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                required
                id="input-Cupo"
                label="Diponibilidad"
                type="text"
                variant="outlined"
                name="disponibilidad"
                value={disponibilidad}
                onChange={(event) => {
                  setDisponibilidad(event.target.value);
                }}
                className={classes.textField}
              />
            </Grid>
            <Grid item xs={12} className={classes.modalBotonesCenter}>
              <Button
                onClick={() => {
                  onGuardar();
                }}
                variant="contained"
                color="primary"
                className={classes.modalBoton}
                disabled={idTipoPlaza > 0 ? false : true}
              >
                Agregar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12} className={classes.modalBotonesCenter}>
          <Button
            onClick={handleClose}
            variant="contained"
            color="Primary"
            className={classes.modalBoton}
          >
            Aplicar
          </Button>
        </Grid>
      </Grid>
    </ModalBase>
  )
}
export default FPlazaPaqueteTerrestre
